/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Reformer_PilatesInputs */

const en_service_type_reformer_pilates = /** @type {(inputs: Service_Type_Reformer_PilatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reformer pilates`)
};

const pl_service_type_reformer_pilates = /** @type {(inputs: Service_Type_Reformer_PilatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilates na reformerze`)
};

/**
* | output |
* | --- |
* | "Reformer pilates" |
*
* @param {Service_Type_Reformer_PilatesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_reformer_pilates = /** @type {((inputs?: Service_Type_Reformer_PilatesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Reformer_PilatesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_reformer_pilates(inputs)
	return en_service_type_reformer_pilates(inputs)
});